(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dw-home-mobile-hero-archive"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    if (!root || root.dataset.dwHeroInit === '1') return;
    root.dataset.dwHeroInit = '1';

    var track = root.querySelector('.dw-home-mobile-hero__track');
    var slides = root.querySelectorAll('.dw-home-mobile-hero__slide');
    if (!track || slides.length === 0) return;

    var dots = root.querySelectorAll('.dw-home-mobile-hero__dot');
    var btnPrev = root.querySelector('.dw-home-mobile-hero__arrow--prev');
    var btnNext = root.querySelector('.dw-home-mobile-hero__arrow--next');
    var autoplay = root.dataset.autoplay === 'true';
    var seconds = parseInt(root.dataset.autoplaySeconds, 10) || 6;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    function slideWidth() {
      return track.clientWidth;
    }

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (btnPrev) btnPrev.disabled = index <= 0;
      if (btnNext) btnNext.disabled = index >= slides.length - 1;
    }

    function goTo(index, behavior) {
      var clamped = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({
        left: clamped * slideWidth(),
        behavior: behavior || (reducedMotion ? 'auto' : 'smooth')
      });
      setActive(clamped);
    }

    function currentIndex() {
      var w = slideWidth();
      if (!w) return 0;
      return Math.round(track.scrollLeft / w);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || reducedMotion || slides.length < 2) return;
      timer = setInterval(function () {
        var next = currentIndex() + 1;
        if (next >= slides.length) next = 0;
        goTo(next);
      }, seconds * 1000);
    }

    track.addEventListener('scroll', function () {
      setActive(currentIndex());
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        goTo(currentIndex(), 'auto');
      }, 150);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.slideIndex, 10) || 0);
        stopAutoplay();
      });
    });

    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        goTo(currentIndex() - 1);
        stopAutoplay();
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () {
        goTo(currentIndex() + 1);
        stopAutoplay();
      });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    setActive(0);
    startAutoplay();
  }

  document.querySelectorAll('[data-section-type="dw-home-mobile-hero-archive"]').forEach(initHero);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-section-type="dw-home-mobile-hero-archive"]');
    if (el) initHero(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["returns-policy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.getElementById('dw-rga-form');
    if (!form) return;

    const nameCombined = document.getElementById('dw-rga-name-combined');

    form.addEventListener('submit', function () {
      const first = String(form.querySelector('[name="contact[First name]"]')?.value || '').trim();
      const last = String(form.querySelector('[name="contact[Last name]"]')?.value || '').trim();
      if (nameCombined) nameCombined.value = (first + ' ' + last).trim();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
